// @ts-strict-ignore
import { Component, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { ProjectNavigationModel } from '../project-navigation.model';
import { ProjectNavigationService } from '../service/project-navigation.service';
import { ReportVO } from '@project/model/vo/report.vo';
import { SelectProjectReportService } from '@project/components/report/service/select-project-report.service';
import { UserSettings } from '@user/model/user-settings';

@Component({
  standalone: false,
  templateUrl: './save-csv.component.html',
  selector: 'app-save-csv'
})
export class SaveCsvComponent implements OnInit {
  @Output() public finish = new EventEmitter<void>();

  @HostBinding(`class.d-flex`) displayFlexClass = true;
  @HostBinding(`class.flex-column`) flexDirectionClass = true;

  public model: ProjectNavigationModel;

  public submitEnabled = false;

  public constructor(
    private userSettings: UserSettings,
    private projectNavigationService: ProjectNavigationService,
    private selectProjectReportService: SelectProjectReportService
  ) {}

  public ngOnInit() {
    this.model = new ProjectNavigationModel();
    this.model.currentModel = {
      importType: null,
      lastSelectedGroupId: this.userSettings.lastSelectedProjectGroupId,
      visibleSharedProjects: true,
      visibleHiddenProjects: true
    };

    this.projectNavigationService.openPreselectedProjectGroup(this.model);
  }

  public updateSubmitEnabled() {
    this.submitEnabled = !this.model.selectedProjectGroups.isEmpty() || !this.model.selectedProjects.isEmpty();
  }

  public saveSelectedCsv() {
    const projectGroupIds: number[] = !this.model.searchMode && this.model.currentProjectFolder ? this.model.selectedProjectGroups.keys() : [];
    const projectIds: number[] = this.model.currentProjectFolder ? this.model.selectedProjects.keys() : [];

    this.selectProjectReportService.openProjectReportPopup(ReportVO.TYPE_CSV, true, projectIds, projectGroupIds);
    this.finish.emit();
  }

  public cancel() {
    this.finish.emit();
  }
}
